export default "__VITE_ASSET__40e1e5f5__"